import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { TenantRolesService } from '../../services/tenant-roles.service';
import { ToastrService } from '../../services/toastr.service';
import { DcrType } from '../../models/tenant-role.model';
import { ApiErrorResponse } from '../../models/auth.model';

@Component({
  selector: 'app-tenant-role-mdm',
  imports: [],
  templateUrl: './tenant-role-mdm.component.html',
  styleUrl: './tenant-role-mdm.component.scss'
})
export class TenantRoleMdmComponent implements OnInit {
  private tenantUid: string;

  isLoading = true;
  dcrTypes: DcrType[] = [];

  constructor(private route: ActivatedRoute, private tenantRolesService: TenantRolesService, private toastrService: ToastrService) {
    this.tenantUid = this.route.snapshot.paramMap.get('slug') ?? '';
  }

  ngOnInit(): void {
    this.loadDcrTypes();
  }

  private loadDcrTypes(): void {
    this.isLoading = true;

    this.tenantRolesService.getDcrTypes(this.tenantUid).subscribe({
      next: (dcrTypes) => {
        this.dcrTypes = dcrTypes;
        this.isLoading = false;
      },
      error: (err: HttpErrorResponse) => {
        this.isLoading = false;
        this.dcrTypes = [];
        this.toastrService.error(this.resolveError(err, 'Unable to load DCR types.'));
      }
    });
  }

  isActiveStatus(status: string): boolean {
    return status?.toLowerCase() === 'active';
  }

  private resolveError(err: HttpErrorResponse, fallback: string): string {
    const body = err?.error as ApiErrorResponse | undefined;
    if (body?.detail) {
      return body.detail;
    }
    if (body?.error?.message) {
      return body.error.message;
    }
    return fallback;
  }
}
